/**
 * BossRageBanner — magenta-pulsing edge vignette + RAGE MODE label that
 * appears when a Space Leviathan (small/giant) drops below 30% HP.
 *
 * Purely cosmetic — no physics, no gameplay change. Renders nothing when
 * `active` is false. The vignette uses CSS keyframes so the canvas's rAF
 * loop never has to repaint to keep the effect alive.
 */
import React from "react";
import { Flame } from "lucide-react";

export function BossRageBanner({ active, hidden }) {
  if (!active || hidden) return null;
  return (
    <div
      data-testid="boss-rage-banner"
      className="absolute inset-0 pointer-events-none"
      aria-hidden
      style={{
        zIndex: 18,
        boxShadow: "inset 0 0 80px 20px rgba(255, 0, 127, 0.45), inset 0 0 24px 6px rgba(255, 60, 60, 0.35)",
        animation: "bossRagePulse 1.1s ease-in-out infinite",
      }}
    >
      <div
        className="absolute top-3 left-1/2 -translate-x-1/2 flex items-center gap-2 px-3 py-1.5 font-mono-cosmic text-[11px] tracking-[0.35em] uppercase"
        style={{
          background: "linear-gradient(90deg, rgba(255,0,127,0.18), rgba(255,90,40,0.22), rgba(255,0,127,0.18))",
          border: "1px solid #ff007f",
          color: "#fff",
          boxShadow: "0 0 16px rgba(255,0,127,0.7), 0 0 32px rgba(255,90,40,0.45)",
          letterSpacing: "0.4em",
        }}
      >
        <Flame className="w-3.5 h-3.5 text-[#ffd700]" />
        <span>Leviathan · Rage Mode</span>
      </div>
    </div>
  );
}

export default BossRageBanner;
